import { useSession } from '@faststore/sdk'
import { useEffect, useState } from 'react'
import { BK_ID_STORAGE_KEY } from 'src/sdk/session/validate'

export const useUserToken = () => {
  const [userToken, setUserToken] = useState<string | undefined>()

  useEffect(() => {
    let mounted = true

    const tokenFromCookie = document?.cookie
      .split(';')
      ?.map((item) => item.trim())
      ?.find((cookie) => cookie.startsWith('_ALGOLIA'))
      ?.split('=')?.[1]

    setUserToken(tokenFromCookie)

    window.aa(
      'onUserTokenChange',
      (token: string) => {
        if (!mounted) return
        setUserToken(token)
      },
      { immediate: true }
    )

    return () => {
      mounted = false
    }
  }, [])

  return userToken
}

export const useAuthenticatedUserToken = () => {
  const { person } = useSession()

  const authenticatedUserToken =
    person && JSON.parse(localStorage.getItem(BK_ID_STORAGE_KEY) || '{}').bk_id

  return authenticatedUserToken
}
